// extracted by mini-css-extract-plugin
export var bar = "featuredProduct-module--bar--f6182";
export var featuredProductTitle = "featuredProduct-module--featured-product-title--582f5";
export var featured_container = "featuredProduct-module--featured_container--4521a";
export var productImg = "featuredProduct-module--productImg--7e6b5";
export var product_desc = "featuredProduct-module--product_desc--734ea";
export var product_row = "featuredProduct-module--product_row--ba741";